import React, { useEffect, useState } from 'react';

import { Card, Button } from 'react-bootstrap';
import { useAuth } from '../../../Auth';
import { useTranslate } from 'react-polyglot';
import FilterSelector from '../../Shared/FilterSelector/FilterSelector';
import PageTable from '../../Shared/PageTable/PageTable';
import MaintenanceResourceModal from '../../Shared/Maintenance/MaintenanceResourceModal';
import EditMaintenance from '../../Shared/Maintenance/EditMaintenance/EditMaintenance';
import StringToIcon from '../../Shared/StringToIcon/StringToIcon';
import DateFormatter from '../../Shared/DateFormatter/DateFormatter';
import PageItems from '../../Shared/PageItems/PageItems';
import './Maintenance.scss';
import { Accordion } from 'react-bootstrap';
import { useAxios } from '../../../AxiosHandler';
import { toast } from 'react-toastify';



function Maintenance() {

    const t = useTranslate();
    const width = window.innerWidth;
    const breakpoint = 620;
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const auth = useAuth();

    // States
    const [maintenanceFilter, setMaintenanceFilter] = useState([]);
    const [updateTable, setUpdateTable] = useState(0);
    const [showMaintenanceLog, setShowMaintenanceLog] = useState(false);
    const [resourceMaintenanceLog, setResourceMaintenanceLog] = useState(false);
    const [currentResourceID, setCurrentResourceID] = useState("");
    const [currentMaintenanceKey, setCurrentMaintenanceKey] = useState();
    const [showEditMaintenance, setShowEditMaintenance] = useState(false);
    const [resources, setResources] = useState<Array<Object>>([]);
    const [maintenanceTypes, setMaintenanceTypes] = useState<Array<Object>>([]);


    // Handlers 
    const handleShowMaintenanceLog = (dataLine, evt) => {
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();
        setResourceMaintenanceLog(dataLine)
        setShowMaintenanceLog(true);
    }
    function handleCloseMaintenanceLog() {
        setUpdateTable(updateTable + 1);
        setShowMaintenanceLog(false);
    }
    const handleShowEditMaintenance = (dataLine) => {
        setCurrentResourceID(dataLine["resourceId"])
        setCurrentMaintenanceKey(dataLine["key"]);
        setShowEditMaintenance(true);
    }

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });
    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    async function fetchData() {
        axios.all([
            axios.single({
                method: "get",
                url: "/api/resources/",
                responseType: "json",
                headers: { 'x-access-token': auth.user["token"] }
            }),
            axios.single({
                method: "get",
                url: "/api/maintenancetypes/",
                responseType: "json",
                headers: { 'x-access-token': auth.user["token"] }
            }),
        ]).then(axios.spread((...res) => {
            setResources(res[0].data);
            setMaintenanceTypes(res[1].data);

        })).catch(err => console.log(err));
        setUpdateTable(updateTable + 1);
    };

    function generateDailyMaintenance() {
        notifySuccess(t("maintenance.generate_washing"))
        axios.single({
            method: "post",
            url: "/api/maintenance/generate/washtasks/bydate",
            data: {
                date: new Date()
            },
            headers: {'x-access-token': auth.user["token"]}
        }).then(res => {
            setUpdateTable(updateTable + 1);
        });
    }

    // PageItem functions
    function renderItem(data, key) {
        if (data.type != undefined) {
            const keyString = key.toString();
            return (
                <Card style={{ marginBottom: "0.3rem" }} className="item-card">
                    <Accordion.Toggle className="clickable" as={Card.Header} eventKey={keyString}>
                        <StringToIcon stylename="icon" icon={data.type} ></StringToIcon>
                        <h5 className="itemCard-title">{data.name}</h5>
                        {data.done == true ? <i className="checkIcon dripicons-checkmark" /> : null}
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={keyString}>
                        <>
                            <Card.Body>
                                <p>{t("maintenance.resource_name")} - {data.resourceName}</p>
                                <p>{data.priority}</p>
                                <p>{data.description}</p>
                                <p><DateFormatter date={data.started} /></p>
                            </Card.Body>
                            <Card.Footer>
                                <Button onClick={() => handleShowEditMaintenance(data)}>{t("maintenance.edit")}</Button>
                                <Button onClick={(evt) => handleShowMaintenanceLog(data, evt)}>{t("maintenance.show_maintenance_resource")}</Button>
                            </Card.Footer>
                        </>
                    </Accordion.Collapse>
                </Card>
            )
        }
    }

    useEffect(() => {
        if (auth.user["userdata"] == undefined) { window.location.href = "/login"; }
        fetchData();
    }, []);

    return (
        <React.Fragment>
            <div className="maincontent" >
                <Card>
                    <Card.Body>
                        <h4 className="card-title" >{t("maintenance.title")}</h4>
                        <div className="no-print">
                            <Button className="newpersonBtn" onClick={generateDailyMaintenance}>{t("maintenance.generate_daily")}</Button>
                            <hr/>
                            <p>{t("maintenance.filters")}</p>
                            <FilterSelector
                                filtersUrl="/api/filters/bytype/"
                                filterType="maintenance"
                                fields={[
                                    { label: t("maintenance.name"), value: "name", type: "string" },
                                    { label: t("maintenance.done"), value: "done", type: "select", choices: [{ label: t("maintenance.done"), value: true }, { label:  t("maintenance.not_done"), value: false }] },
                                    { label: t("maintenance.type"), value: "typename", type: "string" },
                                    { label: t("maintenance.created"), value: "started", type: "date" },
                                    { label: t("maintenance.priority"), value: "priority", type: "string" },
                                ]}
                                onChange={(filter) =>
                                    setMaintenanceFilter(filter.filters)
                                }
                                onAddClick={ auth.user["userdata"]["role"][0] === "Admin" ? () => {} : undefined}
                                onEditClick={ auth.user["userdata"]["role"][0] === "Admin" ? () => {} : undefined}
                                onDeleteClick={ auth.user["userdata"]["role"][0] === "Admin" ? () => {} : undefined}
                                addFilterText={t("maintenance.addfilter")}
                            />
                        </div>
                        {width < breakpoint ?
                            <PageItems
                                dataUrl="/api/resources/maintenance/getAllPaged"
                                hidePagination={false}
                                renderItem={renderItem}
                                updateTable={updateTable}
                                permaFilters={maintenanceFilter}
                                isAccordion={true}
                                defaultSortField="started"
                                defaultSortDirection="desc"
                            />
                            :
                            <PageTable
                                dataUrl="/api/resources/maintenance/getAllPaged"
                                options={{
                                    showFields: [
                                        { label: t("maintenance.name"), field: "name", maxLength: "120" },
                                        {
                                            label: t("maintenance.done"), field: "done",
                                            customFilters: [
                                                { label: t("maintenance.done"), value: true },
                                                { label: t("maintenance.not_done"), value: false },
                                            ],
                                         
                                            override: dataLine => <p className="table-finished">{dataLine["done"] == "true" || dataLine["done"] == true ? t("maintenance.done" ) : t("maintenance.not_done")}</p> 
                                        },
                                        {
                                            label: t("maintenance.type"),
                                            field: "typename",
                                            override: dataLine => {
                                                return (
                                                    
                                                    <div className="table-type">
                                                        <StringToIcon icon={dataLine.type} ></StringToIcon>
                                                        {" "}
                                                        <p>{dataLine.type?.name ?? ""}</p>
                                                    </div>
                                                )
                                            },
                                            customFilters: (maintenanceTypes.map((type) => {return{ label: type["name"], value: type["name"] }}))
                                        },
                                        {
                                            label: t("maintenance.priority"), field: "priority",
                                            customFilters: [
                                                { label: t("maintenance.priority_low"), value: "low" },
                                                { label: t("maintenance.priority_medium"), value: "medium" },
                                                { label: t("maintenance.priority_high"), value: "high" },
                                            ],
                                            
                                            override: dataLine => <p className="table-priority">{t("maintenance.priority_" + dataLine.priority)} </p>
                                        },
                                        { label: t("maintenance.description"), field: "description", maxLength: "120" },
                                        { label: t("maintenance.resource_name"), field: "resourceName" },
                                        {
                                            label: t("maintenance.started"), field:"started", override: (data) => {
                                                return (<DateFormatter date={data["started"]} />
                                                )
                                            }
                                        },
                                    ]
                                }}
                                dataAfter={(dataLine) => <Button className="no-print" onClick={(evt) => handleShowMaintenanceLog(dataLine, evt)}>{t("maintenance.show_maintenance_resource")}</Button>}
                                onLineClick={(dataLine) => handleShowEditMaintenance(dataLine)}
                                hidePagination={false}
                                hidePagesize={false}
                                hideFilter={false}
                                updateTable={updateTable}
                                hover={true}
                                permaFilters={maintenanceFilter}
                                defaultSortField="started"
                                defaultSortDirection="desc"
                            />
                        }


                    </Card.Body>
                </Card>
            </div>

            { resourceMaintenanceLog != false ? 
                <MaintenanceResourceModal 
                    showModal={showMaintenanceLog} 
                    closeModal={handleCloseMaintenanceLog} 
                    resourceID={ resourceMaintenanceLog != undefined ? resourceMaintenanceLog["resourceId"] : undefined} 
                    allResources={resources}
                /> 
            : null
            }
            <EditMaintenance
                showEditMaintenance={showEditMaintenance}
                setShowEditMaintenance={setShowEditMaintenance}
                resourceID={currentResourceID}
                maintenanceKey={currentMaintenanceKey}
                runOnEdit={() => setUpdateTable(updateTable + 1)}
            />
        </React.Fragment>
    )
}

export default Maintenance;


